module.exports = __webpack_public_path__ + "static/media/33-7.264df359.mp3";